// spx-slider-tab
class SpxSliderTab extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this._initElements();
    this._initEvents();
  }
  _initElements() {
    // 使用 this.querySelector 来确保在当前组件内查找
    const swiperContainer = this.querySelector('.swiper-container');
    if (!swiperContainer) {
      console.error('未找到 swiper-container 元素');
      return;
    }

    this.swiper = new Swiper(swiperContainer, {
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      spaceBetween: 16,
      breakpoints: {
        768: {
          spaceBetween: 20,
        }
      },
      speed: 800,
      on: {
        init: () => {
          console.log('Swiper 初始化完成');
        }
      }
    });

    this.tabButtons = this.querySelectorAll('.spx-tab-btn');
    this.tabContents = this.querySelectorAll('.spx-slider-tab-card-content');
    this.activeIndex = 0;
  }

  _initEvents() {
    this.tabButtons.forEach((button) => {
      button.addEventListener('click', () => this.changeTab(button));
    });

    // 监听 slideChange 事件
    this.swiper.on("slideChange", () => {
      console.log('slideChange 触发:', {
        realIndex: this.swiper.realIndex,
        activeIndex: this.swiper.activeIndex
      });
      try {
        this.activeIndex = this.swiper.realIndex;
        if (this.tabButtons[this.activeIndex]) {
          this._updateTabStyles(this.tabButtons[this.activeIndex]);
        }
      } catch (error) {
        console.error('Slide change error:', error);
      }
    });

    // 监听 slideChangeTransitionEnd 事件
    this.swiper.on("slideChangeTransitionEnd", () => {
      console.log('slideChangeTransitionEnd 触发:', {
        realIndex: this.swiper.realIndex,
        activeIndex: this.swiper.activeIndex
      });
      try {
        const event = new CustomEvent('tabChange', {
          detail: {
            index: this.swiper.realIndex,
            direction: this.swiper.swipeDirection
          },
          bubbles: true,
          composed: true
        });
        this.dispatchEvent(event);
      } catch (error) {
        console.error('Slide transition end error:', error);
      }
    });
  }

  changeTab(button) {
    try {
      const tabIndex = parseInt(button.getAttribute("data-tab_index"));
      if (!tabIndex) return;

      // 更新样式
      this._updateTabStyles(button);

      // 触发 Swiper 滑动
      if (this.swiper) {
        this.swiper.slideTo(tabIndex - 1, 800);
      }
    } catch (error) {
      console.error('Change tab error:', error);
    }
  }

  _updateTabStyles(button) {
    const tabIndex = parseInt(button.getAttribute("data-tab_index"));
    if (!tabIndex) return;

    // 更新内容样式
    const tabContent = this.querySelectorAll('.spx-slider-tab-card-content');
    tabContent.forEach((content) => content.classList.remove("active"));
    tabContent[tabIndex - 1]?.classList.add("active");
    
    // 更新按钮样式
    this.tabButtons.forEach((btn) => btn.classList.remove("active"));
    button.classList.add("active");
  }
}

customElements.define("spx-slider-tab", SpxSliderTab);